import { useUserStore, useAppStore, useSessionStore, useBoardStore } from '@/stores'
import { jsonRpc, mediator, messenger } from '@communication'

export default class StartSessionProcedure {
  constructor() {
    this.name = 'startSessionProcedure'
    this.strategyReady = false
    this.app = useAppStore()
    this.session = useSessionStore()
    this.user = useUserStore()
    this.board = useBoardStore()
    this.initCheck = false
    this.joinedParties = new Set()
  }

  install = () => {
    messenger.subscribe(this.name, 'session:time', event => {
      this.session.setStartTimestamp(event.timestamp)
    })
    jsonRpc.on('con:callState', this.onCallStateChanged)
  }

  uninstall = () => {
    jsonRpc.off('con:callState', this.onCallStateChanged)
    messenger.unsubscribe(this.name)
  }

  onCallStateChanged = async (event) => {
    const { state } = event.detail
    console.info(`Call state changed: ${state}`)
    if (state === 'IN_CALL') {
      this.app.transition('START_CALL')
      const response = await mediator.sendAndWait({
        method: 'repository:fetchEvents',
        params: {
          type: 'snapshot',
        },
      })
      const history = JSON.parse(response)
      if (history.length) {
        history.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
        const [last] = history
          .filter(({ data: { type } }) => ['snapshot:take', 'snapshot:dismiss'].includes(type))
          .slice(-1)
        if (last.data.type === 'snapshot:take') {
          this.board.setDelayed(true)
          this.app.transition('draw')
        }
      }
    } else if (state === 'LOBBY') {
      this.app.transition('lobby')
    }
  }
}
